import React from 'react';
import atcLogo from '../images/atc-logo.png';
import schLogo from '../images/lekki.jpeg';
import {Link} from 'react-router-dom';
import '../App.css';


function Nav () { 

  	return(
       <div className="row fixed-top full-width " >
    

      <div className="col-5 d-block d-sm-none standard-padding-tb">
  
                <img src={schLogo} width="100" />
      

      </div>
       <div className="col-7 text-right standard-padding-tb d-block d-sm-none"> 
        <Link to="/">
          <a className="navbar-brand col-8" href=""><img src={atcLogo} width="75" /></a>
        </Link>
          
    </div> 
      <nav className="navbar navbar-expand-lg navbar-light full-width" >
<div className="collapse navbar-collapse" id="navbarSupportedContent">
<Link to="/">
  <a className="navbar-brand col-4" href="#"><img src={atcLogo} width="120" /></a>
  </Link>

  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <ul className="navbar-nav col-10 text-center">
  <li className="col-md-3 offset-md-8 nav-item text-right">
   <img src={schLogo} width="120" />
 </li>
  </ul>
  </div>
</nav>
</div>

  	)
}



export default Nav

